// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PJZbZ7P_cpvsZY8ECgw6{position:fixed;top:0;left:0;width:100vw;height:100vh;display:grid;place-items:center;backdrop-filter:blur(2px);-webkit-backdrop-filter:blur(2px);z-index:100000;background-color:var(--color-spec_modal_bg)}.eSDYROscCmMbw9KmVazV{opacity:0}.eSDYROscCmMbw9KmVazV .v7A9727jEGL3QI5WHSEI{transform:scale(0.95);opacity:0}.glyd4h3A2zEy3WTzB7jb{backdrop-filter:blur(2px);-webkit-backdrop-filter:blur(2px);opacity:1;transition:all 300ms}.glyd4h3A2zEy3WTzB7jb .v7A9727jEGL3QI5WHSEI{transform:scale(1);opacity:1;transition:all 300ms}.u3uzpKzL36k4KyunNEjX{backdrop-filter:blur(2px);-webkit-backdrop-filter:blur(2px);opacity:1}.u3uzpKzL36k4KyunNEjX .v7A9727jEGL3QI5WHSEI{transform:scale(1);opacity:1}.tl5mhPbbasZVVxxjBNYT{opacity:0;transition:all 300ms}.tl5mhPbbasZVVxxjBNYT .v7A9727jEGL3QI5WHSEI{transform:scale(0.95);opacity:0;transition:all 300ms}.v7A9727jEGL3QI5WHSEI{position:relative;padding:50px;background:#fff;min-width:330px;border:1px solid #ecedf5;display:flex;flex-direction:column;align-items:center;box-shadow:0 2px 4px rgba(184,186,202,.25);color:#131a4f}.v7A9727jEGL3QI5WHSEI .ZmzYMM8j9sM29ArpnExV{font-size:30px}.v7A9727jEGL3QI5WHSEI .bisuJ01b4ZSrCkdJLsQX{position:absolute;right:16px;top:16px}.v7A9727jEGL3QI5WHSEI .ZKSSBuQCcN7hI0F_3Q9j{display:flex;flex-direction:column;justify-content:center;align-items:center}.v7A9727jEGL3QI5WHSEI h1{margin-top:0;margin-bottom:10px;font-size:1.5rem;color:var(--color-primary);line-height:24px;font-weight:700;width:100%;text-align:left}.v7A9727jEGL3QI5WHSEI p{color:#131a4f;font-size:1rem;line-height:1.5rem;text-align:left;margin:18px 0}.v7A9727jEGL3QI5WHSEI.IJxQ1tzdT8PHnyMMZ_DN .ZmzYMM8j9sM29ArpnExV{color:#6e32f0}.v7A9727jEGL3QI5WHSEI.UxiTYNtvuygwwsvCVMO6 .ZmzYMM8j9sM29ArpnExV{color:#8496b9}.v7A9727jEGL3QI5WHSEI.VMdZj7LSWC9vGmjMy03O .ZmzYMM8j9sM29ArpnExV{color:#131a4f}.v7A9727jEGL3QI5WHSEI.DJO4QMODCdi9gKy8wvJL .ZmzYMM8j9sM29ArpnExV{color:#fe5779}.v7A9727jEGL3QI5WHSEI.zLr7zRHSpHJubL3ZNTvN .ZmzYMM8j9sM29ArpnExV{color:#91dcfa}.v7A9727jEGL3QI5WHSEI.zcxJrxnWSOiJ_2MXIJah .ZmzYMM8j9sM29ArpnExV{color:#1ec8fa}.v7A9727jEGL3QI5WHSEI._tRKB5bvmRenepPI4mIQ .ZmzYMM8j9sM29ArpnExV{color:#da003e}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `IJxQ1tzdT8PHnyMMZ_DN`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `UxiTYNtvuygwwsvCVMO6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `VMdZj7LSWC9vGmjMy03O`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `DJO4QMODCdi9gKy8wvJL`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `zLr7zRHSpHJubL3ZNTvN`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `zcxJrxnWSOiJ_2MXIJah`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `_tRKB5bvmRenepPI4mIQ`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"modalContainer": `PJZbZ7P_cpvsZY8ECgw6`,
	"modalContainerEnter": `eSDYROscCmMbw9KmVazV`,
	"modal": `v7A9727jEGL3QI5WHSEI`,
	"modalContainerEnterActive": `glyd4h3A2zEy3WTzB7jb`,
	"modalContainerExit": `u3uzpKzL36k4KyunNEjX`,
	"modalContainerExitActive": `tl5mhPbbasZVVxxjBNYT`,
	"icon": `ZmzYMM8j9sM29ArpnExV`,
	"closeIcon": `bisuJ01b4ZSrCkdJLsQX`,
	"content": `ZKSSBuQCcN7hI0F_3Q9j`
};
export default ___CSS_LOADER_EXPORT___;
